const EMPTY_OBJECT = {};

export const initialState = {
	isLoading: false,
	isLoaded: false,
	data: EMPTY_OBJECT
};

export default initialState;
